// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CovidCheckinAndOut from '../_raw/service/icon_covid_checkin_and_out.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CovidCheckinAndOut);
